import React from "react";
import focus from "./about_s4_img3 1@2x.png";
import "./Focus.css";
import one from "../banner/Apple Logo@2x.png";
const Focus = () => {
  return (
    <div className="container py-5">
      <div className="row row-cols-lg-2 row-cols-1">
        <div className="col-12 col-lg-6 order-2 order-lg-1 mt-5 mt-lg-0">
          <div className="text-center text-lg-start">
            <img
              className="img-fluid p-sm-5"
              width={"550px"}
              src={focus}
              alt=""
            />
          </div>
        </div>
        <div className="col-12 col-lg-6 order-1 order-lg-2">
          <button className="btn notero-button">Beautiful UI</button>
          <h1 className="py-3 fw-bolder">
            Focus More With <br />
            <span className="text-color"> Reliable Transaction</span>
          </h1>
          <p className="pe-sm-5 me-sm-5">
            Customize your billing dashboard to your workflow. Organize
            invoices, payments, and client information exactly the way you like
            for maximum efficiency.
          </p>

          <ul className="py-3">
            <li>Instant bill viewing & payment</li>
            <li className="fw-bolder">Easy invoice & payment tracking</li>
            <li>Syncs automatically across devices</li>
            <li>Light & dark mode switching</li>
          </ul>

          {/* <button className="btn px-5 py-3 comon">Discovery Now</button> */}
          <button className="downloadBtn rounded-pill">
            <div className="d-flex  text-center align-items-center ">
              <div className="down px-2">
                <img className="tmg-fluid" src={one} alt="" />
              </div>
              <div className="">
                <p className="mt-3">
                  <span className="ps-3">|</span> Download App
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Focus;
